<script setup lang="ts">
import { SSLyricVideoIndex } from "@/models/frontend-only/LyricVideos";

const props = defineProps<{
  data: SSLyricVideoIndex;
}>();

const subtitle = computed(() => {
  return props.data.leadVoice
    ? `Recording Key: ${getSongKeyVal(props.data.key)}, Voice: ${props.data.leadVoice}`
    : `Recording Key: ${getSongKeyVal(props.data.key)}`;
});
</script>

<template>
  <router-link
    :to="`/lyric-videos/videos/${data.videoId}`"
    class="browse-lv-item"
  >
    <LVThumbnail
      :title="data.title"
      :subtitle="subtitle"
      :tag="data.tags"
      :song-length-seconds="data.duration"
      :force-background-index="data.slideBackground"
    />
    <!-- <div class="thumbnail"></div>
    <div class="after-thumbnail">
      <div class="title">{{ data.title }}</div>
      <div
        v-if="data.leadVoice"
        class="subtitle"
      >
        Recording Key: {{ getSongKeyVal(data.key) }}, Voice:
        {{ data.leadVoice }}
      </div>
      <div
        v-else
        class="subtitle"
      >
        Recording Key: {{ getSongKeyVal(data.key) }}
      </div>
    </div> -->
  </router-link>
</template>

<style scoped lang="postcss">
.browse-lv-item .thumbnail {
  @apply transition-all;
}
.browse-lv-item:hover .thumbnail {
  @apply brightness-95;
}
.thumbnail {
  @apply aspect-video h-auto w-full rounded-lg bg-gray-100;
}
.after-thumbnail {
  @apply mt-1;
}
.title {
  @apply font-bold;
}
.subtitle {
  @apply text-sm opacity-75;
}
</style>
